import React from 'react';
import { Helmet } from 'react-helmet-async';
 // ✅ Import Helmet
import MyOrdersPage from '../elementsui/MyOrdersPage';

const MyOrdersPageWrapper = () => {
  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>My Orders | binzal - Track Your Grocery Deliveries</title>
        <meta name="description" content="Check your order history, track deliveries, and view past grocery purchases on binzal. Fast and reliable service across Bihar." />
        <meta name="keywords" content="binzal orders, my grocery orders, track order Bihar, binzal delivery history" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="My Orders | binzal" />
        <meta property="og:description" content="View and manage your binzal grocery orders, track status, and reorder easily." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <MyOrdersPage />
    </div>
  );
};

export default MyOrdersPageWrapper;
